import { Nullable } from '@kts-front/types';
import { Group, MantineSpacing } from '@mantine/core';
import cn from 'classnames';
import * as React from 'react';

import Text from '../Text';

import { getPlaceTypeIcon, PLACE_TYPE_ICON_SIZE } from './config';

import s from './PlaceType.module.scss';

type PlaceTypeProps = {
  className?: string;
  name: Nullable<string> | undefined;
  size?: 'sm' | 'xs';
  gap?: MantineSpacing;
  textClassName?: string;
  withIcon?: boolean;
};

const PlaceType: React.FC<PlaceTypeProps> = ({ className, name, size, gap, textClassName, withIcon = false }) => {
  if (!name) {
    return null;
  }

  const Icon = withIcon ? getPlaceTypeIcon(name) : null;

  if (!Icon) {
    return (
      <Text size={size} className={cn(className, textClassName)}>
        {name}
      </Text>
    );
  }

  return (
    <Group align="center" wrap="nowrap" gap={gap ?? (size === 'xs' ? 'xxxxs' : 'xxxs')} className={className}>
      <Icon size={PLACE_TYPE_ICON_SIZE} className={s.root__icon} />
      <Text size={size} className={textClassName}>
        {name}
      </Text>
    </Group>
  );
};

export default React.memo(PlaceType);
